module.exports = __webpack_public_path__ + "media/images/pic/anime/glasses-17b96b2dff9d78de293dd2756066b1b9.svg";